import { render, staticRenderFns } from "./SpecimenChickenCintilloAla.vue?vue&type=template&id=38138a20&scoped=true"
import script from "./SpecimenChickenCintilloAla.vue?vue&type=script&lang=js"
export * from "./SpecimenChickenCintilloAla.vue?vue&type=script&lang=js"
import style0 from "./SpecimenChickenCintilloAla.vue?vue&type=style&index=0&id=38138a20&prod&lang=scss&scoped=true"
import style1 from "./SpecimenChickenCintilloAla.vue?vue&type=style&index=1&id=38138a20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38138a20",
  null
  
)

export default component.exports